import { useState, useEffect } from "react";
import { Typography, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import {
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import {
  findProductById,
  updateProduct,
} from "../../../Redux/Customers/Product/Action";
import api from "../../../config/api";
import { UNSAFE_DataRouterStateContext } from "react-router-dom";
// import "./CreateProductForm.css";

const initialSizes = [
  { name: "S", quantity: 0 },
  { name: "M", quantity: 0 },
  { name: "L", quantity: 0 },
];

const UpdateProductPopup = ({ open, handleClose, productId }) => {
  const [productData, setProductData] = useState({
    images: [],  // Store multiple image files here
    brand: "",
    title: "",
    color: "",
    discountedPrice: "",
    price: "",
    discountPersent: "",
    size: initialSizes,
    quantity: "",
    topLavelCategory: "",
    secondLavelCategory: "",
    thirdLavelCategory: "",
    description: "",
  });

  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");
  //   const productState = useSelector(state => state.product || {});
  // const { product, loading, error } = productState;


  // Fetch product data if productId is passed


  const [product, setproduct] = useState()
  
  useEffect(() => {
    const fetchproduct = async () => {
      if(productId){
        const data = await api.get(`/api/products/id/${productId}`);
        setproduct(data.data) 
        console.log("products by id : ", data.data);
      }
    
    }
    fetchproduct()
  }, [productId]);


  useEffect(() => {
    if (product) {
      setProductData({
        ...productData,
        images: product.imageUrl || [],
        brand: product.brand || "",
        title: product.title || "",
        color: product.color || "",
        discountedPrice: product.discountedPrice || "",
        price: product.price || "",
        discountPersent: product.discountPersent || "",
        size: product.size || initialSizes,
        quantity: product.quantity || "",
        topLavelCategory: product.topLavelCategory || "",
        secondLavelCategory: product.secondLavelCategory || "",
        thirdLavelCategory: product.thirdLavelCategory || "",
        description: product.description || "",
      });
    }
  }, [product]);



  // Handle input change for text fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle size change for each size field
  const handleSizeChange = (e, index) => {
    let { name, value } = e.target;
    if (name === "size_quantity") {
      name = "quantity";  // Rename the field to quantity for size
    }

    const sizes = [...productData.size];
    sizes[index][name] = value;
    setProductData((prevState) => ({
      ...prevState,
      size: sizes,
    }));
  };

  // Handle file change (image upload)
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);  // Convert FileList to array
    setProductData((prevState) => ({
      ...prevState,
      images: files,  // Store the selected files in the images array
    }));
  };

  // Handle form submission for update
  const handleSubmit = (e) => {
    e.preventDefault();

    // Prepare FormData for API submission (include both text data and files)
    const formData = new FormData();

    // Append images to formData
    productData.images.forEach((image) => {
      formData.append("images", image);
    });

    // Append other fields to formData
    for (const key in productData) {
      if (key === "size") {
        // For sizes, append them as JSON strings (array of objects)
        productData.size.forEach((size) => {
          formData.append("sizes[]", JSON.stringify(size));
        });
      } else if (key !== "images") {
        formData.append(key, productData[key]);
      }
    }

    // Dispatch action to update product with the form data
    dispatch(updateProduct({ formData, productId }))


    // Close the popup after submission
    handleClose();
  };



  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>Update Product</DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <Grid container spacing={2}>
            {/* Image Upload Section */}
            <Grid item xs={12}>
              <input
                type="file"
                multiple
                accept="image/*"
                name="images"
                onChange={handleImageChange}
              />
              {productData.images.length > 0 && (
                <div>
                  <h4>Selected Images:</h4>
                  <ul>
                    {productData.images.map((file, index) => (
                      <li key={index}>{file.name}</li>
                    ))}
                  </ul>
                </div>
              )}
            </Grid>

            {/* Other form fields */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Brand"
                name="brand"
                value={productData.brand}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Title"
                name="title"
                value={productData.title}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Color"
                name="color"
                value={productData.color}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Quantity"
                name="quantity"
                value={productData.quantity}
                onChange={handleChange}
                type="number"
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Price"
                name="price"
                value={productData.price}
                onChange={handleChange}
                type="number"
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Discounted Price"
                name="discountedPrice"
                value={productData.discountedPrice}
                onChange={handleChange}
                type="number"
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Discount Percentage"
                name="discountPersent"
                value={productData.discountPersent}
                onChange={handleChange}
                type="number"
              />
            </Grid>

            {/* Category Selection */}
            <Grid item xs={6} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Top Level Category</InputLabel>
                <Select
                  name="topLavelCategory"
                  value={productData.topLavelCategory}
                  onChange={handleChange}
                  label="Top Level Category"
                >
                  <MenuItem value="men">Men</MenuItem>
                  <MenuItem value="women">Women</MenuItem>
                  <MenuItem value="kids">Kids</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Second Level Category</InputLabel>
                <Select
                  name="secondLavelCategory"
                  value={productData.secondLavelCategory}
                  onChange={handleChange}
                  label="Second Level Category"
                >
                  <MenuItem value="clothing">Clothing</MenuItem>
                  <MenuItem value="accessories">Accessories</MenuItem>
                  <MenuItem value="brands">Brands</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Third Level Category</InputLabel>
                <Select
                  name="thirdLavelCategory"
                  value={productData.thirdLavelCategory}
                  onChange={handleChange}
                  label="Third Level Category"
                >
                  <MenuItem value="Kurtas">Mens Kurtas</MenuItem>
                  <MenuItem value="Shoes">Shoes</MenuItem>
                  <MenuItem value="Lengha Choli">Lengha Choli</MenuItem>
                  <MenuItem value="Saree">Saree</MenuItem>
                  <MenuItem value="Dresses">Dresses</MenuItem>
                  <MenuItem value="Gowns">Gowns</MenuItem>
                  <MenuItem value="Tops">Tops</MenuItem>
                  <MenuItem value="T-Shirts">T-Shirts</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                name="description"
                value={productData.description}
                onChange={handleChange}
                multiline
                rows={3}
              />
            </Grid>

            {/* Size selection */}
            {productData.size.map((size, index) => (
              <Grid container item spacing={3} key={index}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Size Name"
                    name="name"
                    value={size.name}
                    onChange={(event) => handleSizeChange(event, index)}
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Quantity"
                    name="size_quantity"
                    type="number"
                    value={size.quantity}
                    onChange={(event) => handleSizeChange(event, index)}
                    required
                    fullWidth
                  />
                </Grid>
              </Grid>
            ))}

            <Grid item xs={12}>
              <Button variant="contained" sx={{ p: 1.8 }} size="large" type="submit">
                Update Product
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateProductPopup;
